import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {EventService} from '@spartacus/core';
import {switchMap, take} from 'rxjs/operators';
import {UserAccountChangedEvent, UserAccountFacade} from '@spartacus/user/account/root';

@Injectable({
  providedIn: 'root'
})
export class UserAccountFacadeUpdateGuard  {

  constructor(
    private userAccountFacade: UserAccountFacade,
    private eventService: EventService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    this.eventService.dispatch(new UserAccountChangedEvent());
    return this.userAccountFacade.get().pipe(
      take(1),
      switchMap(() => of(true)),
    );
  }
}
